<template>
  <div class="profileChangeDarkmode" id="profileChangeDarkmode">

    <NavigationBar>
      <template v-slot:left>
        <img v-on:click="goBack" class="back" src="../assets/icons/ic_16_back.svg">
      </template>
      <template v-slot:center>
        {{ $t('profile.dark_mode') }}
      </template>
      <template v-slot:right>
      </template>
    </NavigationBar>

    <form @submit.prevent="saveAndBack">

      <div class="input-container">

        <div class="input-checkbox">
          <input
            id="darkMode"
            name="darkMode"
            type="checkbox"
            v-model="darkMode"
            v-on:change="darkModeChanged"
          />
          <label for="darkMode" style="border-bottom: 0px;">{{ $t('profile.dark_mode_use_dark') }}</label>
        </div>

        <div class="input-button-row">
          <button type="submit" name="button">
            {{ $t('button_save_text') }}
          </button>
        </div>

      </div>

    </form>

    <div class="input-container" style="margin-top: 24px;">
      
      <div class="input-button-row">
        <button v-on:click="reloadWebView" name="button">
          Reload
        </button>
      </div>

    </div>
    
  </div>
</template>

<script>
import NavigationBar from './../components/NavigationBar'
import { TOAST_DURATION } from '../main'

const DARKMODE_STORAGE_KEY = 'spmdarkmode'

export default {
  name: 'profileChangeDarkmode',
  components: { NavigationBar },
  data () {
    return {
      darkMode: true
    }
  },
  mounted () {
    this.darkMode = this.$store.state.darkmode === true
  },
  methods: {
    reloadWebView() {
      try {
        if (window.TeamtipAppInterface !== undefined && window.TeamtipAppInterface !== null) {
        } else if (window.webkit && window.webkit.messageHandlers.TeamtipAppInterface !== undefined && window.webkit.messageHandlers.TeamtipAppInterface !== null) {
          const b = window.webkit.messageHandlers.TeamtipAppInterface.postMessage('reloadWebView')
        } else {
        }
      } catch (e) {
      }
    },
    goBack () {
      this.$router.push('/profile')
    },
    persistDarkmode (value) {
      this.$store.dispatch('setDarkmode', value)
      window.localStorage.setItem(DARKMODE_STORAGE_KEY, value ? 'true' : 'false')
    },
    darkModeChanged () {
      this.persistDarkmode(this.darkMode)
    },
    saveAndBack () {
      this.persistDarkmode(this.darkMode)
      this.$toast.open({
        message: this.$i18n.t('profile.settings_saved'),
        position: 'top',
        duration: TOAST_DURATION,
        type: 'success'
      })
      this.$router.push('/profile')
    }
  }
}
</script>

<style lang="scss" scoped>
.profileChangeDarkmode {

  form {
    padding-top: 16px;
  }

  h1 {
    text-align: center;
  }

  p {
    text-align: center;
    margin-bottom: 26px;
  }
}
</style>
